<template>
  <div class="edit-wrap">
    <el-page-header class="header" @back="goBack" content="编辑文章">
    </el-page-header>
    <div
      style="
        width: 1000px;
        min-height: 800px;
        border: 1px solid #eee;
        margin: auto;
        padding: 30px;
      "
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="文章标题" prop="article_title">
          <el-col :span="24">
            <el-input v-model="ruleForm.article_title"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="文章简介" prop="article_summary">
          <el-input
            v-model="ruleForm.article_summary"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="article_author">
          <el-col :span="12">
            <el-input v-model="ruleForm.article_author"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="文章封面" ref="headimgUpload" prop="cover_picture">
          <el-upload
            class="avatar-uploader"
            action="https://www.haixingcloud.com:8000/api/oss/upload/image"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="文章内容">
          <tinymce v-model="content" ref="content" :height="500" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交修改</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Tinymce from '../../Tinymce'
export default {
  data () {
    return {
      uploadUrl: 'https://www.haixingcloud.com:8000/api/oss/upload/image',
      files: {},
      ruleForm: {
        article_title: '',
        article_summary: '',
        article_author: '海星云团队',
        cover_picture: ''
      },
      rules: {
        article_title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        article_summary: [
          { required: true, message: '请填写文章简介', trigger: 'blur' }
        ],
        article_author: [
          { required: true, message: '请填文章作者 例如：海星云团队', trigger: 'blur' }
        ],
        cover_picture: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      content: '',
      imageUrl: '',
      id: ''
    }
  },
  components: { Tinymce },
  watch: {
    content: (newVal, oldVal) => {
      console.log(newVal)
      this.content = newVal
    }
  },
  mounted () {
    console.log('欢迎来到编辑文章页面')
    console.log(this.$route.query.id)
    this.id = this.$route.query.id
    this.getDetails()
    sessionStorage.setItem('editManageNews', true)
  },
  methods: {
    getDetails () {
      this.http.chawzid(this.id).then((res) => {
        if (res.data.code === 200) {
          console.log('详情：', res.data.data.article)
          this.ruleForm = res.data.data.article
          this.imageUrl = res.data.data.article.cover_picture
          this.content = res.data.data.article.article_content
        }
      })
    },
    goBack () {
      this.$router.push({
        path: './ManageNews'
      })
    },
    // 覆盖 el-upload 组件默认的 上传
    uploadFile (item) {
      // 创建 FormData 对象
      let param = new FormData()
      // 通过 append() 方法来追加数据
      param.append('image', item.file)
      // 通过 get 方法对值进行读取
      console.log('param:', param)
      // 请求接口
      axios({
        method: 'post',
        url: this.uploadUrl,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: param,
        processData: false
      })
        .then((res) => {
          this.imageUrl = res.data.data
          this.ruleForm.image = res.data.data
          this.$refs.headimgUpload.clearValidate() // 关闭图片校验
          console.log(res)
          console.log(this.imageUrl)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    beforeAvatarUpload (file) {

    },
    handleAvatarSuccess (res, file) {

    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          console.log('error submit!!')
          return false
        }
        if (valid && !this.content) {
          this.$message.error('请输入文章内容')
          return
        }
        const dataList = {
          id: this.id,
          article_title: this.ruleForm.article_title,
          article_summary: this.ruleForm.article_summary,
          article_author: this.ruleForm.article_author,
          article_type: 1400,
          cover_picture: this.ruleForm.cover_picture,
          article_content: this.content
        }
        this.http.upNews(dataList).then((res) => {
          alert('修改成功!')
          this.resetForm('ruleForm')
          this.$router.push({
            path: './ManageNews'
          })
        }).catch(error => {
          this.$message({
            message: error.response.data.message2,
            type: 'warning'
          })
        })
      })
    },
    resetForm (formName) {
      this.imageUrl = ''
      this.$refs.content.setContent('')
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-wrap {
  .header {
    margin: 20px 0 20px 20px;
  }
  .demo-ruleForm {
    width: 100% !important;
    /deep/ .el-form-item__error {
      line-height: 0 !important;
    }
    .avatar-uploader {
      /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        input {
          display: none !important;
        }
      }
      /deep/ .el-upload:hover {
        border-color: #409EFF;
      }
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 250px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 250px;
    height: 150px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/newsPage/edit.vue